import { makeVar, useReactiveVar } from "@apollo/client";
import { getCookie, setCookie } from "../handleCookies/handleCookies";

type Theme = "light" | "dark";
export const COOKIE_NAME = "marketplace-theme";

/**
 * Gets stored theme setting from cookie.
 * If no cookie is set it defaults to the users system setting.
 * If the user's system does not support themes it defaults to the light theme.
 */
export const isDarkTheme = () => {
  const cookieValue = getCookie(COOKIE_NAME);

  switch (cookieValue) {
    case "light":
      return false;
    case "dark":
      return true;
    default:
      return window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)").matches : false;
  }
};

export const storeThemeSetting = (newSetting: Theme) => {
  setCookie(COOKIE_NAME, newSetting, 90);
};

export const isDarkThemeVar = makeVar<boolean>(isDarkTheme());

export type UseTheme = () => readonly [boolean, () => void];

export const useTheme = (): ReturnType<UseTheme> => {
  const isDark = useReactiveVar(isDarkThemeVar);

  const toggleTheme = () => {
    const newValue = !isDark;
    isDarkThemeVar(newValue);
    storeThemeSetting(newValue ? "dark" : "light");
  };

  return [isDark, toggleTheme];
};
